<script>
	export default {
		name: 'Theader',

		data() {
			return {

			}
		},
		created() {
			this.$nextTick(function() {
				this.next();
				this.scrollMenu();
				this.showMenu();
			});
		},
		methods: {
			next() {
				let dom = document.querySelectorAll('nav li a');
				dom.forEach(function(element) {
					element.addEventListener('click', (e) => {
					if(e.target.href.search('#contato')){
							console.log('teste');
						}
					})
				}, this);
			},

			scrollMenu() {
				const element = document.querySelector('.nav');
				const resizeLogo = document.querySelector('.votolegal');

				window.addEventListener('scroll', (e) => {
					const newOffset = window.scrollY;
					const currentRouteName = this.$route.name;

					if (currentRouteName === 'home') {
						if (newOffset > 95 && window.matchMedia("(min-width: 1200px)").matches) {
							element.classList.add('animate');

							if (newOffset > 200) {
								resizeLogo.classList.add('votolegal-small');
							}

						} else if (newOffset > 62 && window.matchMedia("(min-width: 928px)").matches) {
							element.classList.add('animate');
							resizeLogo.classList.add('votolegal-small');

						} else if (newOffset > 0 && window.matchMedia("(max-width: 929px)").matches) {
							element.classList.add('animate-small');
							resizeLogo.classList.add('votolegal-small');

						} else {
							element.classList.remove('animate');
							element.classList.remove('animate-small');
							resizeLogo.classList.remove('votolegal-small');
						}
					} else {
						if (newOffset > 1) {
							element.classList.add('animate');
							resizeLogo.classList.add('votolegal-small');
						} else {
							element.classList.remove('animate');
							resizeLogo.classList.remove('votolegal-small');
						}
					}
				});
			},

			showMenu() {
				const element = document.querySelector('.mobile-button');
				const menu = document.querySelector('.menu-wrap');
				element.addEventListener('click', function() {
					menu.classList.toggle('show');
				})

			}
		}
	}
</script>

<template>
  <div :class="`${this.$route.name === 'home' ? 'home-page' : 'internal-pages'} nav-top`">
    <header class="nav">
      <nav class="nav-bar container">
        <button class="mobile-button">
          <span />
          <span />
          <span />
        </button>
        <ul class="brand-wrap">
          <li class="logo votolegal">
            <a href="/">Voto Legal</a>
          </li>
        </ul>
        <ul class="menu-wrap">
          <li class="menu-item">
            <a
              href="https://comunidade.appcivico.com/c/voto-legal/5"
              target="_blank"
            >
              Perguntas frequentes
            </a>
          </li>
          <li class="menu-item">
            <router-link to="/perguntas-frequentes#contato">
              Fale com a gente
            </router-link>
          </li>
          <li class="menu-item">
            <a
              target="_blank"
              class="login-button"
              href="https://participe.votolegal.com.br/"
            >Entrar</a>
          </li>
        </ul>
      </nav>
    </header>
  </div>
</template>

<style lang="scss">

.home-page .nav {
	position: absolute;

	@media (min-width: 929px) {
		height: 70px;
		background-color: transparent;
		padding-top: 4rem;
	}

	@media (min-width: 1200px) {
		padding-top: 5.625rem;
	}
}

.internal-pages .nav {
	position: absolute;
	background-color: white;
	padding-top: 0;

	@media (min-width: 929px) {
		height: 70px;
		padding-top: 0.5em;
	}
}

.nav {
	position: relative;
	margin: 0;
	width: 100%;
	z-index: 2;
	font-weight: normal;
	background-color: white;
	padding-top: 0.25rem;
	padding-bottom: 0.25rem;
	height: 60px;
	transition-property: background-color, height;

	transition-duration: 0.3s, 1s;

	@media (min-width: 929px) {
		height: 70px;
	}

	&.animate,
	&.animate-small {
		position: fixed;
		height: 50px;
		background-color: white;
		padding-top: 0.25em;
		padding-bottom: 0.25rem;


		@media (min-width: 929px) {
			height: 58px;
		}
	}

	ul {
	list-style-type: none;
	}

	li {
	display: block;
	float: left;
	margin: 0 10px;
	}

	.brand-wrap {
		position: absolute;
		transform: translate(-50%, -50%);
		margin-top: 0.25em;
		top: 50%;
		left: 50%;

		@media (min-width: 929px) {
			margin-top: 0.25em;
			transform: translateX(0);
			left: 2rem;
			top: 0;
		}

		&::after {
			content: '';
			display: table;
			clear: both;
		}

	}

	.brand-wrap a {
		display: block;
		height: 100%;
	}

	.logo {
		background-image: url("../../img/logo/votolegal.png");
		float: none;
		overflow: hidden;
		text-indent: 110%;
		white-space: nowrap;
		background-repeat: no-repeat;
		direction: ltr;
	}

	.votolegal {
		background-size: 140px auto;
		width: 140px;
		height: 40px;

		overflow: hidden;

		@media (min-width: 480px) {
			transition: background-size, 0.8s;
			background-size: 180px auto;
			width: 180px;
			height: 55px;
		}

		@media (min-width: 1200px) {
			background-size: 220px auto;
			width: 220px;
			height: 63px;
		}
	}

	.votolegal-small {

		@media (min-width: 480px) {
			background-size: 150px auto;
			width: 150px;
			height: 50px;
		}

		@media (min-width: 480px) {
			background-size: 160px auto;
			width: 160px;
			height: 50px;
		}
	}

	.menu-wrap {
		margin-top: 0.25em;
		position: absolute;
		text-align: center;
		overflow: hidden;


		@media (max-width: 928px) {
			opacity: 0;
			max-height: 0;
			overflow: hidden;

			&.show {
				transition: opacity, 0.3s;
				opacity: 9;
				display: block;
				margin-left: auto;
				margin-right: auto;
				margin-top: 0.25em;
				background-color: white;
				width: 100%;
				max-height: 1000px;
				position: absolute;
				padding: 0;
				padding-top: 0.2em;
				max-height: none;

				right: 0;
				left: 0;
				top: 100%;

				&:last-child {
					padding-bottom: 2rem;
				}
			}
		}

		@media (min-width: 929px) {
			margin-left: 2em;
		}

		@media (min-width: 929px) {
			margin-left: 14em;
		}

		@media (min-width: 1200px) {
			margin-left: 18em;
		}

	}

	.menu-item {
		width: auto;
		padding-left: 1rem;
		padding-right: 1rem;
		padding-bottom: 1rem;
		padding-top: 1rem;

		@media (max-width:928px) {
			float: none;
		}

		a {
			color: rgb(51, 102, 102);
			font-size: 1em;
			font-weight: bold;

			&:hover {
				color: #4ab957;
			}
		}
	}

	a.login-button {
		position: relative;
		color: white !important;
		border-radius: 8px;
		background-color: #336666;
		margin-top: 0.5rem;
		padding-top: 0.5rem;
		padding-bottom: 0.5rem;
		padding-left: 0.8rem;
		padding-right: 0.8rem;

		&:hover {
			background-color: #4ab957;
			color: white !important;
		}
	}

	&:after {
		display: table;
		content: '';
		clear: both;
	}

	.greetingsection .nav-bar  {
		padding-top: 5.5625rem;
	}

	.nav-bar {

		button {
			display: none;
			outline: none;
			@media (max-width: 928px) {
				display: block;
			}

			&.mobile-button {
				cursor: pointer;
				width: 50px;
				height: 40px;
				border-radius: 8px;
				border: solid 2px #76848f;
				background-color: transparent;
				float: left;
				margin-left: 0;
				margin-top: 0.25rem;
				text-align: center;
				position: relative;
				z-index: 2;
				transition: all 0.5s;

				span {
					display: block;
					border-bottom: solid #76848f 2px;
					width: 80%;
					padding: 3px;
					transition: all 0.5s;

					&:first-child {
						padding-top: 0px;
					}
					&:hover {
						border-bottom: solid #4bb958 2px;
					}
				}

				&:hover {
					border: solid 2px #4bb958;
					background-color: white;
					transition: all 1s;

					span {
						border-bottom: solid #4bb958 2px;
						transition: all 1s;
					}
				}
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// _source/javascript/components/theader.vue